import { useState, useEffect } from 'react';
import { X } from 'lucide-react';

const Banner = () => {
  const [isVisible, setIsVisible] = useState(true);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const content = "[ALERT] Você está usando a versão mobile e ela está obsoleta. Por favor, atualize para a versão desktop."

  const fetchDica = async () => {
    setLoading(true);
    setError(null);
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  };

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    if (user.token) {
      fetchDica();
    }
  }, []);

  if (!isVisible) return null;

  return (
    <div className="relative isolate bg-white dark:bg-gray-800 border-b border-gray-100 dark:border-gray-700">
      <div className="mx-auto max-w-7xl px-4 py-3 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between flex-wrap">
          <div className="flex items-center flex-1 min-w-0">
            <span className="flex rounded-lg bg-pink-500 p-1">
              <svg
                className="h-5 w-5 text-white"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fillRule="evenodd"
                  d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                  clipRule="evenodd"
                />
              </svg>
            </span>
            <p className="ml-3 text-sm font-medium text-gray-900 dark:text-gray-100">
              {loading ? (
                <span className="inline-flex items-center">
                  <svg className="animate-spin h-4 w-4 text-pink-500 mr-2" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
                  </svg>
                  Carregando...
                </span>
              ) : error ? (
                <span className="text-red-600">Erro ao carregar conteúdo</span>
              ) : (
                <span>{content}</span>
              )}
            </p>
          </div>
          <div className="flex-shrink-0">
            <button
              onClick={() => setIsVisible(false)}
              className="flex rounded-md p-1 hover:bg-gray-100 dark:hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-pink-500"
            >
              <span className="sr-only">Fechar</span>
              <X className="h-5 w-5 text-gray-400 dark:text-gray-100" aria-hidden="true" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Banner;